module.exports = __webpack_public_path__ + "img/success.d909497b.png";